import React, { useState } from 'react';
import TarotCard from './TarotCard';
import { PERSONALITY_CARD_STYLES, mapPersonalityToCard } from '../utils/tarotMapper';
import './QuizPage.css';

/**
 * ResultsPreview - Test component to preview TarotCard results for all personality types
 *
 * Access at: http://localhost:3000/results-preview
 *
 * Features:
 * - Dropdown to select any of the 8 personality types
 * - Shows the full TarotCard experience (with auto-flip after 5 seconds)
 * - Useful for testing card images and styling
 */
const ResultsPreview = () => {
  const personalityTypes = Object.keys(PERSONALITY_CARD_STYLES);
  const [selectedPersonality, setSelectedPersonality] = useState(personalityTypes[0]);

  // Generate mock card data for selected personality
  const cardData = mapPersonalityToCard(
    selectedPersonality,
    `This is a test summary for ${selectedPersonality}. In the real quiz, this text comes from the backend API and describes the user's personality based on their quiz answers. The summary provides insights about their personality traits, strengths, and characteristics.`
  );

  return (
    <div className="quiz-page tarot-card-mode">
      {/* Personality Selector - Fixed at top */}
      <div style={styles.selectorContainer}>
        <label style={styles.label}>Select Personality Type:</label>
        <select
          value={selectedPersonality}
          onChange={(e) => setSelectedPersonality(e.target.value)}
          style={styles.select}
        >
          {personalityTypes.map((type) => (
            <option key={type} value={type}>
              {PERSONALITY_CARD_STYLES[type].cardNumber} - {type}
            </option>
          ))}
        </select>
        <a href="/" style={styles.backLink}>← Back to Quiz</a>
      </div>

      {/* TarotCard Component */}
      <TarotCard
        key={selectedPersonality} // Force re-mount when personality changes (resets auto-flip timer)
        cardData={cardData}
        userEmail="test@example.com"
        user={null}
      />
    </div>
  );
};

const styles = {
  selectorContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    padding: '12px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    zIndex: 1000,
    flexWrap: 'wrap',
  },
  label: {
    color: '#F5F1E8',
    fontFamily: 'Manrope, sans-serif',
    fontSize: '14px',
    fontWeight: '600',
  },
  select: {
    padding: '8px 12px',
    fontSize: '14px',
    fontFamily: 'Manrope, sans-serif',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#F5F1E8',
    color: '#2C2C2C',
    cursor: 'pointer',
    minWidth: '250px',
  },
  backLink: {
    color: '#FAA21B',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: '600',
    marginLeft: 'auto',
  },
};

export default ResultsPreview;
